import { BatteryDefinition } from '../components/Battery';
import { BusDefinition } from '../components/Bus';
import { CapacitorDefinition } from '../components/Capacitor';
import { ChargerDefinition } from '../components/Charger';
import { CircuitBreakerDefinition } from '../components/CircuitBreaker';
import { ControllerDefinition } from '../components/Controller';
import { CombinerBoxDefinition } from '../components/CombinerBox';
import { CustomDefinition } from '../components/Custom';
import { ContactorDefinition } from '../components/Contactor';
import { ConverterDefinition } from '../components/Converter';
import { DiodeDefinition } from '../components/Diode';
import { DisconnectDefinition } from '../components/Disconnect';
import { FuelCellDefinition } from '../components/FuelCell';
import { FuseDefinition } from '../components/Fuse';
import { GeneratorDefinition } from '../components/Generator';
import { GroundingDefinition } from '../components/Grounding';
import { HVACDefinition } from '../components/HVAC';
import { LoadDefinition } from '../components/Load';
import { LightDefinition } from '../components/Light';
import { MeterDefinition } from '../components/Meter';
import { MotorDefinition } from '../components/Motor';
import { OtherDefinition } from '../components/Other';
import { PanelDefinition } from '../components/Panel';
import { PowerDistributionUnitDefinition } from '../components/PowerDistributionUnit';
import { PrechargeDefinition } from '../components/Precharge';
import { RapidShutdownDefinition } from '../components/RapidShutdownDevice';
import { ConnectorDefinition } from '../components/Connector';
import { ReferenceDefinition } from '../components/Reference';
import { SolarDefinition } from '../components/Solar';
import { SolutionDefinition } from '../components/Solution';
import { CurrentTransducerDefinition } from '../components/CurrentTransducer';
import { VoltageTransducerDefinition } from '../components/VoltageTransducer';
import { TransferSwitchDefinition } from '../components/TransferSwitch';
import { TransformerDefinition } from '../components/Transformer';
import { UtilityDefinition } from '../components/Utility';
import { WindDefinition } from '../components/Wind';
import { HydroDefinition } from '../components/Hydro';
import { CableDefinition } from '../components/Cable';
import { SoftwareDefinition } from '../components/Software';

import { ComponentDefinition } from '../../types/ComponentDefinition';

const components: {
    [type in ComponentDefinition['type']]: ComponentDefinition;
} = {
    battery: BatteryDefinition,
    bus: BusDefinition,
    capacitor: CapacitorDefinition,
    breaker: CircuitBreakerDefinition,
    charger: ChargerDefinition,
    controller: ControllerDefinition,
    combinerBox: CombinerBoxDefinition,
    contactor: ContactorDefinition,
    converter: ConverterDefinition,
    currentTransducer: CurrentTransducerDefinition,
    custom: CustomDefinition,
    diode: DiodeDefinition,
    disconnect: DisconnectDefinition,
    fuelCell: FuelCellDefinition,
    fuse: FuseDefinition,
    generator: GeneratorDefinition,
    grounding: GroundingDefinition,
    hvac: HVACDefinition,
    hydro: HydroDefinition,
    load: LoadDefinition,
    light: LightDefinition,
    meter: MeterDefinition,
    motor: MotorDefinition,
    other: OtherDefinition,
    panel: PanelDefinition,
    connector: ConnectorDefinition,
    powerDistributionUnit: PowerDistributionUnitDefinition,
    precharge: PrechargeDefinition,
    rapidShutdownDevice: RapidShutdownDefinition,
    reference: ReferenceDefinition,
    solar: SolarDefinition,
    solution: SolutionDefinition,
    transferSwitch: TransferSwitchDefinition,
    transformer: TransformerDefinition,
    utility: UtilityDefinition,
    voltageTransducer: VoltageTransducerDefinition,
    wind: WindDefinition,
    cable: CableDefinition,
    software: SoftwareDefinition,
};

export default components;
